<div class="acs-page">

    <!-- Loading State -->
    <div *ngIf="isLoading" class="acs-page__loading">
      <acs-loading-spinner size="large" message="Loading member roster..." />
    </div>

    <!-- Error State -->
    <acs-alert 
      *ngIf="error" 
      type="error" 
      title="Error Loading Member Roster"
      [message]="error" 
      [dismissible]="true"
      (dismissed)="error = null" />

    <!-- Main Content -->
    <div *ngIf="!isLoading" class="acs-page__content">
    
    <!-- Header Section -->
    <div class="acs-page-header">
      <div class="acs-page-header__title-section">
        <h1 class="acs-page-header__title">Member Roster</h1>
        <p class="acs-page-header__subtitle">
          {{ TotalMembers }} total member{{ TotalMembers === 1 ? '' : 's' }}
          <span class="acs-page-header__role">({{ userRole }})</span>
        </p>
      </div>
    </div>

    <!-- Summary Cards -->
    <!-- <acs-summary 
        [summaryCards]="summaryCards"
        [gridColumns]="4"
        cardSize="medium"
        spacing="normal" /> -->

    <!-- Bulk Actions Bar -->
    <div class="acs-bulk-actions" *ngIf="selectedCount > 0">
      <div class="acs-bulk-actions__info">
        <span class="acs-bulk-actions__selection-count">
          {{ selectedCount }} member{{ selectedCount === 1 ? '' : 's' }} selected
        </span>
      </div>
      <div class="acs-bulk-actions__buttons">
        <acs-button 
          variant="primary" 
          size="small"
          [dropdown]="true"
          [dropdownOptions]="exportOptions"
          dropdownPosition="left"
          [disabled]="isLoading"
          (dropdownOptionSelected)="onExportOptionSelected($event)">
          📊 Export {{ selectedCount > 0 ? 'Selected' : 'All' }}
        </acs-button>
        <acs-button 
          variant="text" 
          size="small"
          (clicked)="clearSelection()">
          Clear Selection
        </acs-button>
      </div>
    </div>

    <!-- Member Data Grid -->
    <div class="acs-grid-section">
      <div class="acs-grid-section__header">
        <h2 class="acs-grid-section__title">Member Details</h2>
        <p class="acs-grid-section__description">
          Complete member information with contact details, membership status, and dues information.
          Click on any member row to view detailed information.
        </p>
      </div>

      <div class="acs-grid-section__container">
        <acs-data-grid
          #memberGrid
          [serverSide]="true"
          [entityName]="entityName"
          [columns]="gridColumns"
          [pageSize]="100"
          [infiniteScroll]="false"
          [autoLoad]="true"
          [showPagination]="true"
          [showPageSizeSelector]="true"
          [pageSizeOptions]="[10, 25, 50, 100, 250]"
          [sortable]="true"
          [filterable]="true"
          [enableDropdownFilters]="true"
          [searchable]="true"
          searchPlaceholder="Search members..."
          [selectable]="'none'"
          [exportable]="true"
          [exportFilenamePrefix]="'member-roster'"
          [virtualScrolling]="true"
          [stickyHeader]="true"
          emptyText="No members found"
          (selectionChange)="onGridSelectionChange($event)"
          (serverError)="onServerError($event)">
        </acs-data-grid>
      </div>
    </div>
  </div>
</div>